import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import * as Icons from 'react-feather';
import {useList} from 'store/list'
import {useCore} from 'store/core'
import Loading from 'components/Loading'
import ListSearch from 'components/list/ListSearch'
import ListPagination from 'components/list/ListPagination'
import Delete from "./Delete";
import {handleSuccessMessages} from "store/auth";

export default function Menus() {
   const path = {
      baseRoute: '/panel/menus',
      aliasName: 'منو ها',
      type: 'Menus',
   };
   const {dispatch, clear, getList, list, load, remove, listSearch, from, to, total} = useList();
   const [showDelete, setShowDelete] = useState(false);
   const [item, setItem] = useState(false);

   useEffect(() => {
      dispatch(getList(path));
      return () => {
         dispatch(clear())
      }
   }, []);

   return (
      <>
         <Delete title="حذف منو" show={showDelete} close={() => {
            setShowDelete(false);
         }} submite={() => {
            dispatch(remove(path, list, item.id, () => {
               handleSuccessMessages("عملیات با موفقیت انجام شد")
               dispatch(getList(path))
               setShowDelete(false);
            }))
         }}/>

         <div className="content" style={{marginBottom: 80}}>
            <h2 className="intro-y text-lg font-medium mt-10">
               منو ها
            </h2>
            <div className="grid grid-cols-12 gap-6 mt-5">
               <div className="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
                  <Link to="/settings/menus/add">
                     <a className="btn btn-primary shadow-md mr-2">ایجاد منو</a>
                  </Link>
                  {load &&
                  <div className="hidden md:block mx-auto text-gray-600 text-white">در حال بارگذاری</div>}
                  {!load &&
                  <div className="hidden md:block mx-auto text-gray-600 text-white">
                     {total ? `نمایش ${from} تا ${to} از ${total}` : null}
                  </div>}
                  <ListSearch search={(key) => {
                     dispatch(listSearch(path, key))
                  }}/>
               </div>

               <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
                  <table className="table table-report -mt-2">
                     <thead>
                     <tr>
                        <th className="whitespace-nowrap text-center">شناسه</th>
                        <th className="whitespace-nowrap text-center">عنوان منو</th>
                        <th className="whitespace-nowrap text-center">نوع</th>
                        <th className="whitespace-nowrap text-center">عملیات</th>
                     </tr>
                     </thead>
                     {load && <Loading/>}
                     {list && !list.length > 0 && <h3 className="w-3/6 flex justify-center">چیزی یافت نشد</h3>}
                     <tbody>
                     {!load && list && list.length > 0 && list.map((item) => (
                        <tr className="intro-x">
                           <td className="w-16 text-center">
                              {item.id}
                           </td>
                           <td>
                              <p className="font-medium whitespace-nowrap text-center">{item.name}</p>
                           </td>
                           <td className="text-center">

                           </td>
                           <td className="table-report__action w-56">
                              <div className="flex justify-center items-center">
                                 <Link to={`/settings/menus/edit/${item.id}`}>
                                    <a className="flex items-center ml-3 cursor-pointer">
                                       <Icons.CheckSquare className="w-4 h-4 ml-1"/>
                                       ویرایش
                                    </a>
                                 </Link>
                                 <a className="flex items-center text-theme-6 cursor-pointer"
                                    onClick={() => {
                                       setItem(item);
                                       setShowDelete(true);
                                    }}>
                                    <Icons.Trash2 className="w-4 h-4 ml-1 "/>حذف </a>
                              </div>
                           </td>
                        </tr>))}
                     </tbody>
                  </table>
               </div>
               <ListPagination getList={(page, perPage) => {
                  dispatch(getList(path, page, perPage))
               }}/>
            </div>
         </div>
      </>
   );
}
